import { Button, DialogActions, DialogTitle } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { WorkspaceUserRole } from "common/interfaces";
import WorkspaceController, { WorkspaceControllerState } from "js/controllers/WorkspaceController";
import { UserProfile } from "js/react/components/Avatar";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";

const FlexDiv = styled.div`
    display: flex;
`;

const SpacedPTag = styled.p`
    letter-spacing: .1px;
`;

const ProfileContainer = styled.div`
    display: flex;
    padding: 10px;
`;

const OwnersAndLibrariansProfilesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
`;

const StyledDialogTitle = styled(DialogTitle)`
    &&& {
        padding: 34px 34px 0;
    }
`;

const StyledDialogContent = styled(DialogContent)`
    &&& {
        padding: 0 34px 0;
    }
`;

export interface MissingManageTeamFolderPermissionsDialogProps {
    folderId: string;
    closeDialog: () => void;
}

export const MissingManageTeamFolderPermissionsDialog = WorkspaceController.withInitializedState(
    function MissingManageTeamFolderPermissionsDialog(props: MissingManageTeamFolderPermissionsDialogProps & WorkspaceControllerState) {
        const { closeDialog, resourceFolders, folderId } = props;
        const { t } = useTranslation();

        const folder = resourceFolders.find(f => f.id === folderId);
        if (!folder) {
            throw new Error("Folder not found");
        }

        const usersWithAccess = WorkspaceController.getUsersWithAccessToResourceFolder(folderId);
        const ownersWithAccess = usersWithAccess.filter(user => user.role === WorkspaceUserRole.OWNER);

        return (
            <BeautifulDialog closeDialog={closeDialog}>
                <StyledDialogTitle>{t("Sorry, you don't have permission to manage folder access.")}</StyledDialogTitle>
                <StyledDialogContent>
                    <SpacedPTag>{t("This folder's settings only allow folder owners to update folder access. You can reach out to the following team members for help")}:</SpacedPTag>
                    <FlexDiv>
                        <OwnersAndLibrariansProfilesContainer>
                            {ownersWithAccess.map(user => {
                                return (
                                    <ProfileContainer key={user.uid}>
                                        <UserProfile profile={user} />
                                    </ProfileContainer>
                                );
                            })}
                        </OwnersAndLibrariansProfilesContainer>
                    </FlexDiv>
                </StyledDialogContent>
                <DialogActions>
                    <Button color="primary" onClick={closeDialog} >
                        {t("Got It")}
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
);
